(function (global) {
  'use strict';

  global.NewHomeSource = global.NewHomeSource || {};
  global.NewHomeSource.Carousel = global.NewHomeSource.Carousel || {};

  class PercentOfView {
    /**
     * Initializes a new instance of the class with a default view size of 0.
     */
    constructor() {
      this.viewSize = 0;
    }

    /**
     * Sets the size of the view.
     *
     * @param {number} viewSize - The size to set for the view. If not provided, defaults to 0.
     */
    setViewSize(viewSize) {
      this.viewSize = viewSize || 0;
    }

    /**
     * Calculates a value that represents the given percentage of the view size.
     *
     * @param {number} number - The percentage to calculate (0-100).
     * @returns {number} The calculated value as a portion of the view size.
     */
    measure(number) {
      return this.viewSize * (number / 100);
    }
  }

  global.NewHomeSource.Carousel.PercentOfView = PercentOfView;
}(window));
